import {
  R2DDashboard,
  DispatchDashboard,
  ShipmentsDashboard,
} from "@svan-garaaz/lmd";
import { withApiConfig } from "../hoc/withApiConfig";

const sharedDashboardProps = {
  maskDeliveryContactDetails: true,
  userName: "Garaaz",
  enableDistanceTabs: true,
  refreshConfig: {
    enabled: true,
    intervalMinutes: 10,
  },
};

export const ApiAwareR2DOrders = withApiConfig(
  R2DDashboard,
  sharedDashboardProps,
);

export const ApiAwareDispatchDashboard = withApiConfig(
  DispatchDashboard,
  sharedDashboardProps,
);

export const ApiAwareShipmentsDashboard = withApiConfig(ShipmentsDashboard);
